<template>
  <VCard :elevation="elevation" :color="color">
    <slot />
  </VCard>
</template>

<script setup lang="ts">
import { VCard } from 'vuetify/components/VCard';

export interface Props {
  elevation?: string | number;
  color?: string;
}

withDefaults(defineProps<Props>(), {
  elevation: undefined,
  color: 'white',
});
</script>
